module.exports = __webpack_public_path__ + "img/star-white.930006a7.svg";